import ServerInfo from "./ServerInfo";
import KickMessageManager from "./KickMessageManager";
import DefaultMainPage from "../../pages/DefaultMainPage";

const serverInfoMenuItems = [
    {path: "/serverInfo", component: <ServerInfo/>, label: '서버 정보'},
    {path: "/serverInfo/kickMessageManager", component: <KickMessageManager/>, label: '강퇴 메시지 관리'},
];

export const serverInfoRoutes = {
    path: '/serverInfo',
    component: <DefaultMainPage buttons={serverInfoMenuItems}/>,
    children: serverInfoMenuItems
}